import { AppConfiguration } from '@app-config/models/app-configuration';

export const appConfigurationDefault: AppConfiguration = {
    layout: {
        toolbar: { hidden: false },
        footer: { hidden: false },
        spinner: { hidden: true }
    },
    company: null
};